import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApplicationData } from 'src/app/data/application.data';
import { ContextData } from 'src/app/data/context.data';
import { FontsLibrairie } from 'src/app/data/fonts.librairie';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { UserService } from './user.service';
import { UserImageData } from 'src/app/data/user/user-image.data';
import { CONFIGURATION_MODE, CONFIGURATION_CONTEXT } from 'src/app/data/configuration.data';
import { UserExcelData } from '../data/user/user-excel.data';
import { TranslateService } from '@ngx-translate/core';

declare const initDatas: any;

export enum ApplicationStates {
  INIT = 0,
  LOADING = 1,
  READY = 2,
  ERROR = 3,
  FATALERROR = 4,
}

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  public state:ApplicationStates;

  // current layer
  public currentLayerData: LayerData = null;

  /**
   * Constructor
   */
  constructor(
    private applicationData:ApplicationData,
    private http:HttpClient,
    private userService:UserService,
    private translate:TranslateService
  ) {

  }

  /**
   * Load new configuration
   */
  public init():Promise<any> {
    this.state = ApplicationStates.INIT;
    ContextData.setDPI(ContextData.DPI);

    return new Promise((resolve, reject) => {
      ContextData.initLogo().then(
        (result: any) => {
          this.prepareUserDatas().then(
            (result: any) => {
              this.getFontsData().then(
                (result: any) => {
                  this.getSheetData().then(
                    (result: any) => {

                      this.applicationData.configuration.mode = CONFIGURATION_MODE.NORMAL;
                      this.applicationData.configuration.mustControlOverlapseBeforePrint = false;

                      if(initDatas.project){
                        this.applicationData.configuration.context = CONFIGURATION_CONTEXT.SAVED;
                        this.userService.loadProject(initDatas.project.file).then(
                          (result: any) => {
                            this.applicationData.userProjectId = initDatas.project.id;
                            this.applicationData.userProjectName = initDatas.project.name;
                            this.applicationData.userProjectFolder = initDatas.project.folder;
                            this.state = ApplicationStates.READY;
                            let promises: Array<any> = [];
                            for (let label of result.labels) {
                              promises.push(()=> this.applicationData.configuration.addLabel(label) );
                            }

                            promises.reduce(
                              (p, fn) => p.then(fn),
                              Promise.resolve()
                            ).then(() => {
                              let configuration = this.applicationData.configuration;
                              configuration.displayLabel(configuration.labels[0]);
                              //console.log("init() -> resolve");
                              resolve(true);
                            }).catch(error => {
                              reject(false);
                              console.error(error);
                            });
                          },
                          (error: any) => {
                            console.error(error);
                          },
                        ).catch((e: Error) => { console.error(e); });

                      } else {

                        this.applicationData.configuration.context = CONFIGURATION_CONTEXT.NEW;

                        this.state = ApplicationStates.READY;
                        if (this.applicationData.configuration.multiFormat) {
                          this.applicationData.configuration.addSheet().then(
                            (result: any) => {
                              let configuration = this.applicationData.configuration;
                              configuration.displayLabel(configuration.labels[configuration.labels.length - configuration.sheetProperties.layouts.length]);
                              resolve(true);
                            },
                            (error: any) => {
                              console.error(error);
                            },
                          ).catch((e: Error) => { console.error(e); });
                        } else {
                          // console.log("this.applicationData.configuration.addLabel() INIT");
                          this.applicationData.configuration.addLabel().then(
                            (result: any) => {
                              let configuration = this.applicationData.configuration;
                              configuration.displayLabel(configuration.labels[0]);
                              resolve(true);
                              // console.log("this.applicationData.configuration.addLabel() COMPLETE");
                            },
                            (error: any) => {
                              console.error(error);
                            },
                          ).catch((e: Error) => { console.error(e); });
                        }

                      }





                    },
                    (error: any) => {
                      console.log(error);
                      this.state = ApplicationStates.FATALERROR;
                      reject(false);
                    },
                  ).catch((e: Error) => { this.unknownError(reject, e); });
                },
                (error: any) => {
                  this.state = ApplicationStates.FATALERROR;
                  console.log(error);
                  reject(false);
                },
              ).catch((e: Error) => { this.unknownError(reject, e); });
            },
            (error: any) => {
              this.state = ApplicationStates.FATALERROR;
              console.log(error);
              reject(false);
            },
          ).catch((e: Error) => { this.unknownError(reject, e); });
        },
        (error: any) => {
          this.state = ApplicationStates.FATALERROR;
          console.log(error);
          reject(false);
        },
      ).catch((e: Error) => { this.unknownError(reject, e); });
    });
  }

  /**
  * Load fonts data
  */
  private getFontsData(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.ASSETS_SERVER + '/assets/fonts.json').subscribe((response: any) => {
        let _fontDatas = response;
        _fontDatas.userFonts = initDatas.userAssets.filter(ua=>ua.type===2).map((ua:any)=>{
          return {
            "css": ua.name,
            "is_bold": false,
            "is_italic": false,
            "is_italic_bold": false,
            "name": ua.name,
            "url": ua.src
          };
        });
        FontsLibrairie.setData(_fontDatas);
        resolve(true)
      }, (err) => {
        console.log(err);
        this.unknownError(reject);
      });
    });
  }

  /**
  * Load user data
  */
  private prepareUserDatas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userService.loadUserDatas().then(()=>{
        resolve(true);
      }, (error)=>{
        // not logged
        resolve(true);
      });
    });
  }

  /**
  * Load shapes data
  */
  public getShapesData(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.ASSETS_SERVER + '/assets/symbols.json').subscribe((response: any) => {

        resolve(response.symbol_collection);
      }, (err) => {
        console.log(err);
        this.unknownError(reject);
      });
    });
  }

  /**
   * Load sheet data
   */
  private getSheetData():Promise<any> {


    return new Promise((resolve, reject) => {

      this.applicationData.configuration.setData(initDatas.sheet, initDatas.design).then((result: any) => {
        resolve(true);
      },(error: any) => {
        console.log(error);
        reject(false);
      }).catch((e: Error) => { this.unknownError(reject, e); });
		});
  }

  /**
	 * Reject with Unknown Error
	 */
  unknownError(reject, e: Error = null) {
    this.state = ApplicationStates.FATALERROR;
    console.log(e);
    reject({
      "type": "RuntimeException",
      "message": {
        "criticity": "FATALERROR",
        "text": "ERROR.UNKNOWN_ERROR"
      }
    });
  }

  get data():ApplicationData{
    return this.applicationData;
  }

}
